const PREFIX = 'PARTNER_BANKING_INFO_';

export const GET_BANKING_INFO = `${PREFIX}GET_BANKING_INFO`;
export const GET_BANKING_INFO_SUCCESS = `${PREFIX}GET_BANKING_INFO_SUCCESS`;
export const UPDATE_BANKING_INFO = `${PREFIX}UPDATE_BANKING_INFO`;
export const SET_BANK_ACCOUNT = `${PREFIX}SET_BANKACCOUNT_INFO`;
